export default "__VITE_ASSET__CAStWp93__"